import apis from "../../core/apis.js";

class BulkbonusesResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.bulkbonuses).get(options);
  }

  get(id) {
    return this.$resource(apis.bulkbonuses + id).get();
  }

  search(search = "") {
    return this.$resource(apis.bulkbonuses).get({ search });
  }

  post(item) {
    return this.$resource(apis.bulkbonuses).save(item);
  }

  update(id, item) {
    return this.$resource(apis.bulkbonuses + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  getBulkBonusTemplates(options) {
    return this.$resource(apis.bulkbonuses + "templates").get(options);
  }
}

export default BulkbonusesResource;



// WEBPACK FOOTER //
// ./src/resources/bulkbonuses/bulkbonuses.resource.js